import { InternalModule } from '../launch.constants';
import { ListItem, ListItemIcon, ListItemName, ListItemDescription } from '../styles';

interface ModuleRowProps {
  module: InternalModule;
  onOpen: (path: string) => void;
}

export const ModuleRow = ({ module, onOpen }: ModuleRowProps) => {
  const Icon = module.icon;
  return (
    <ListItem
      role="button"
      tabIndex={0}
      onClick={() => onOpen(module.path)}
      onKeyDown={(e) => e.key === 'Enter' && onOpen(module.path)}
    >
      <ListItemIcon $color={module.color}>
        <Icon size={15} strokeWidth={1.75} />
      </ListItemIcon>
      <ListItemName>{module.name}</ListItemName>
      <ListItemDescription>{module.description}</ListItemDescription>
    </ListItem>
  );
};
